<template>
    <div class="price-setting-box" v-loading="loading > 0">
      <Header :title="title"></Header>
      <div class="container">
        <div class="content">
          <div class="title">商品名称：{{ info.name }}</div>
          <div class="table">
            <div class="name">可见用户设置</div>
            <table>
              <tr>
                <th :colspan="key.length" class="sku">规格明细</th>
                <th :colspan="memberArr.length">用户可见性</th>
              </tr>
              <tr class="name-box">
                <td
                  :class="{ sku: index === key.length - 1 }"
                  v-for="(item, index) in key"
                  :key="item"
                >
                  {{ item }}
                </td>
                <td v-for="(item, index) in memberArr" :key="index">
                  {{ item.name }}
                </td>
              </tr>
              <tr class="value-box" v-for="(item, index) in skuArr" :key="index">
                <td
                  :class="{ sku: index1 === key.length - 1 }"
                  v-for="(item1, index1) in key"
                  :key="item1"
                >
                  {{ item[item1] }}
                </td>
                <td v-for="(member, memberIndex) in memberArr" :key="memberIndex">
                  <!-- <el-input
                    style="width: 100px; text-align: center"
                    placeholder=""
                    v-model.number="item[member.value].price"
                    size="small"
                  ></el-input> -->
                  <input
                    type="text"
                    class="price-input"
                    v-model.number="item[member.value].price"
                    onkeypress="/([0-9]|\.)/.test(event.key)"
                    oninput="value = /^\d+(\.{1}\d{0,2})?/g.exec(value) ? /^\d+(\.{1}\d{0,2})?/g.exec(value)[0] : ''"
                  />
                </td>
              </tr>
            </table>
          </div>
          <div class="btn-box">
            <!-- <button class="cancel-btn" @click="handleCancel">取消</button> -->
            <button class="confirm-btn" @click="handleConfirm">保存</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script type="text/ecmascript-6">
  import Header from '../../components/common/header';
  export default {
    components: {
      Header
    },
    name: 'price-setting',
    data() {
      return {
        title: {
          // 页面标题
          firstTitile: '商品管理',
          secondTitle: '可见用户设置'
        },
        configure: {
          pic: '',
          msg: ''
        },
        memberArr: [
          {
            name: '游客',
            value: -1
          },
          {
            name: '消费者',
            value: 0
          },
          {
            name: '体验官',
            value: 1
          },
          {
            name: '总监',
            value: 2
          },
          {
            name: '总裁',
            value: 3
          }
          // {
          //   name: '合伙人',
          //   value: 4
          // },
          // {
          //   name: '董事',
          //   value: 5
          // },
          // {
          //   name: '运营中心',
          //   value: 6
          // }
        ],
        skuArr: [],
        key: [],
        rules: {},
        info: {},
        loading: 0
      };
    },
    async mounted() {
      let query = this.$route.query;
      if (query && query.gid) {
        this.gid = query.gid;
        await this.getGoodDetail(query.gid);
        this.getInfo(query.gid);
      }
    },
    computed: {},
    methods: {
      // 获取分享详情
      getGoodDetail(gid) {
        this.loading++;
        return this.httpGet(this.$root.goodsDetail, { gid }).then(
          (res) => {
            this.loading--;
            this.skuArr = res.skuList.map((item) => {
              let obj = {};
              item.attrs.forEach((attr) => {
                obj[attr.keyName] = attr.value;
              });
              let memberObj = {};
              this.memberArr.forEach((member) => {
                memberObj[member.value] = {
                  gid: +gid,
                  kid: item.kid,
                  role: member.value,
                  price: null
                };
              });
              return {
                ...item,
                ...obj,
                ...memberObj
              };
            });
            this.info = res;
            this.key = this.getAttrName(res.skuList);
            console.log(this.skuArr);
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      },
      getInfo(gid) {
        this.loading++;
        this.httpGet(this.$root.getPriceInfo, { gid }).then(
          (res) => {
            this.loading--;
            console.log(this.skuArr);
            let obj = {};
            res.forEach((item) => {
              if (obj[item.kid]) {
                obj[item.kid][item.role] = {
                  gid: item.gid,
                  kid: item.kid,
                  role: item.role,
                  price: item.price
                };
              } else {
                obj[item.kid] = {
                  [item.role]: {
                    gid: item.gid,
                    kid: item.kid,
                    role: item.role,
                    price: item.price
                  }
                };
              }
            });
            this.skuArr = this.skuArr.map((item) => {
              return { ...item, ...obj[item.kid] };
            });
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      },
      getAttrName(skus) {
        let newAttrs = [];
        skus.forEach((item) => {
          item.attrs.forEach((attr) => {
            if (newAttrs.indexOf(attr.keyName) < 0) {
              newAttrs.push(attr.keyName);
            }
          });
        });
        return newAttrs;
      },
      handleConfirm() {
        let list = [];
        let flag = true;
        this.skuArr.forEach((item) => {
          this.memberArr.forEach((member) => {
            list.push(item[member.value]);
            if (!item[member.value].price) flag = false;
          });
        });
        if (!flag) {
          this.$message.warning('请完善价格');
          return;
        }
        console.log(list);
        this.loading++;
        this.httpPost(this.$root.setPriceInfo, list).then(
          (res) => {
            this.loading--;
            this.getInfo(this.info.gid);
            this.$message.success('设置成功');
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      }
    }
  };
  </script>
  <style lang="stylus" rel="stylesheet/stylus">
  @import '~assets/public.styl';
  </style>
  <style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '~assets/main.styl';
  
  .price-setting-box {
    height: 100%;
    width: 100%;
    flex-y(flex-start, flex-start);
    overflow-y: hidden;
    background: bg-color;
  
    .container {
      box-sizing: border-box;
      height: 100%;
      width: 100%;
      overflow-y: auto;
      flex-y(flex-start, flex-start);
      padding: 24px;
  
      // content 表格
      .content {
        flex: 1;
        width: 100%;
        font-size: 14px;
        background: white;
        box-sizing: border-box;
        padding: 0 32px;
        border-radius: 2px;
  
        .title {
          height: 85px;
          line-height: 85px;
          word(18px, #333);
          border-bottom: 1px solid #F6F6F6;
        }
  
        .table {
          .name {
            word(20px, #333);
            padding: 24px 0;
            font-weight: 600;
          }
  
          table {
            width: 100%;
            border: 1px solid #E8E8E8;
  
            .name-box {
              background: #F6F6F6;
            }
  
            .value-box {
              td {
                border-top: 1px solid #E8E8E8;
              }
  
              .price-input {
                width: 100px;
                height: 32px;
                border: 1px solid #E8E8E8;
                text-align: center;
                border-radius: 2px;
                color: #999;
              }
            }
  
            td, th {
              height: 54px;
              text-align: center;
            }
  
            td {
              word(14px, #333);
            }
  
            th {
              word(15px, #333);
            }
  
            tr {
              .sku {
                border-right: 1px solid #E8E8E8;
              }
            }
  
            >>>.el-checkbox__inner {
              border-radius: 10px;
              transform: scale(1.5);
            }
          }
        }
  
        .configure-form {
          margin: 50px 80px 0;
  
          .input {
            width: 150px;
          }
        }
  
        .tip {
          word(15, #EA0000);
          margin-top: 24px;
          margin-left: 80px;
        }
  
        .btn-box {
          background: white;
          width: 100%;
          flex-x(center);
          padding-bottom: 28px;
          position: absolute;
          bottom: 0;
          left: 0;
  
          .cancel-btn {
            width: 96px;
            height: 40px;
            cancel-btn();
            // border-radius: 23px;
          }
  
          .confirm-btn {
            width: 96px;
            height: 40px;
            margin-left: 20px;
            confirm-btn();
          }
        }
      }
    }
  }
  </style>